// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssociatedEntityProposalCountQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type AssociatedEntityProposalCountQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalConnection', totalCount: number }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, hypotheticalGrats?: Array<{ __typename?: 'HypotheticalGRAT', id: string, hypotheticalWaterfall: { __typename?: 'EstateWaterfall', id: string } }> | null } | null } | null> | null } };

export const Operations = {
  Query: {
    AssociatedEntityProposalCount: 'AssociatedEntityProposalCount' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const AssociatedEntityProposalCountDocument = gql`
    query AssociatedEntityProposalCount($entityId: ID!) {
  proposals(where: {hasEntityProposalsWith: {hasEntityWith: {id: $entityId}}}) {
    totalCount
  }
  entities(where: {id: $entityId}, first: 1) {
    edges {
      node {
        id
        hypotheticalGrats {
          id
          hypotheticalWaterfall {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssociatedEntityProposalCountQuery__
 *
 * To run a query within a React component, call `useAssociatedEntityProposalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssociatedEntityProposalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssociatedEntityProposalCountQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useAssociatedEntityProposalCountQuery(baseOptions: Apollo.QueryHookOptions<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>(AssociatedEntityProposalCountDocument, withFetchPolicyContext(options));
      }
export function useAssociatedEntityProposalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>(AssociatedEntityProposalCountDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAssociatedEntityProposalCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>(AssociatedEntityProposalCountDocument, withFetchPolicyContext(options));
        }
export type AssociatedEntityProposalCountQueryHookResult = ReturnType<typeof useAssociatedEntityProposalCountQuery>;
export type AssociatedEntityProposalCountLazyQueryHookResult = ReturnType<typeof useAssociatedEntityProposalCountLazyQuery>;
export type AssociatedEntityProposalCountSuspenseQueryHookResult = ReturnType<typeof useAssociatedEntityProposalCountSuspenseQuery>;
export type AssociatedEntityProposalCountQueryResult = Apollo.QueryResult<AssociatedEntityProposalCountQuery, AssociatedEntityProposalCountQueryVariables>;